import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { roswellNmConfig } from "./data";

export default function RoswellNmPage() {
  return <CityPageTemplate config={roswellNmConfig} />;
}